import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

export const CallbackPage = () => {
  return <div>You're logged in</div>;
};
